export const FIXED = '.header_fixed > .header_fixed';
export const BURGER_BOX = '#burger__box';
export const BURGER = '#btn__burger';
export const NAV = '#navigation__box';
export const TOP_POSITION_CLASS = 'main__header_top-position';
export const ACTIVE_CLASS = '_active';
export const HIDE_SCROLL_BODY_CLASS = 'hide-scroll';
export const BURGER_MENU_OPENED = 'burger-opened';
export const MENU_WITH_CHILDREN = '.nav__item_has-child';
export const SUB_MENU_BTN_CLASS = 'sub-menu__toggle';
export const SUB_MENU_OPEN_CLASS = 'nav__item_open';
export const SUB_MENU_NAV_HAS_SCROLL = 'sub-menu__nav--has-scroll';
export const SUB_MENU_LIST = '.sub-menu__nav';
export const SUB_MENU_ITEM = '.sub-menu__item';
export const SUB_MENU_SCROLL = '.nav-item__native-scroll';
export const COLLAPSED_CLASS = 'header_collapsed';
export const HEADER_WRAPPER = '.header__wrap';
export const HEADER_LAYOUT_WRAPPER = '.header__wrap > .header-layout-wrapper';
export const WITHOUT_BURGER_CLASS = 's-wrapper_original';
export const WITH_BURGER_CLASS = 's-wrapper_collapsed';
export const NAV_BOX_WRAP = '.nav__box-wrap > .s-wrapper';
export const CART_CLASS = 'header-cart';
export const LOGO_CLASS = 'header-logo';
